import { useCallback } from 'react'
import { useSprig } from '@mc/sprig'

export const useSprigTracking = () => {
  const { track, identify, isConfigured } = useSprig()

  const trackCertificateEvent = useCallback(
    (eventName: string, properties?: Record<string, unknown>) => {
      if (!isConfigured) return

      track({
        eventName,
        properties: {
          ...properties,
          product: 'certificates',
          timestamp: new Date().toISOString(),
        },
      })
    },
    [track, isConfigured],
  )

  const identifyUser = useCallback(
    (
      userId?: string,
      attributes?: Record<string, string | number | boolean>,
    ) => {
      if (!isConfigured) return

      identify({
        userId,
        attributes: {
          ...attributes,
          product: 'certificates',
          isLoggedIn: true,
        },
      })
    },
    [identify, isConfigured],
  )

  return {
    trackCertificateEvent,
    identifyUser,
    isConfigured,
  }
}
